import React from "react";
import Head from "next/head";
import fetch from 'isomorphic-unfetch';
import GridGallery from "../components/gridGallery";
import BreadCrumb from "../components/breadcrumb";

export default class extends React.Component {
    static async getInitialProps({ req , query: { page }}) {
        const pageNum= page ? page : '1';
        let props = {}
        if (typeof window === 'undefined') {
            try {
                const galleryResp = await fetch(process.env.NEXT_STATIC_API+'/api/gallery/list/6?page='+pageNum);
                const galleryData = await galleryResp.json();

                props.gallery = galleryData;
                props.pageNum= pageNum;

            } catch (e) {
                props.error = 'Unable to fetch AsyncData on server';
            }
        }
        return props;
    }
    constructor(props) {
        super(props);
        this.state = { ...props };
    }

    render() {
        const { gallery } = this.state
        
        return (
            <div className="">
                <Head>
                    <title>Galeri Terbaru - PT Jasamarga Tollroad Operator</title>
                </Head>
                <div className="container">
               {/*  <BreadCrumb nextMenu={[{
                        text: "Galeri",
                        url: "/galeri"
                    }]} /> */}
                </div>
                <div className="pull-up">
                    <GridGallery feed={gallery} currPage={this.state.pageNum}  usePage={true} useSearch={true} />
                </div>
                <style jsx>
                    {`
                        .pull-up{
                            margin-top:-4em;
                        }
                    `}
                </style>
            </div>
        )
    }
}